import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { BehaviorSubject } from 'rxjs';
import { HAConfig } from '../models/HAConfig';

interface CurrentHostResponse {
  currentHostIP: string;
}

@Injectable({
  providedIn: 'root'
})
export class HaService {
  
  public currentHostIp: string = '';

  constructor(private http: HttpClient, private envs: EnvironmentService) {
    this.initializeCurrentHostIp();
  }

  initializeCurrentHostIp() {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/SyncHPC/CurrentHost`;
    return this.http.get<CurrentHostResponse>(baseUrl).subscribe({
      next: (response) => {
        if (response && response.currentHostIP) {
          this.currentHostIp = response.currentHostIP;
        } else {
          this.currentHostIp = window.location.host;
        }
      },
      error: (error) => {
        this.currentHostIp = window.location.host;
      }
    });
  }

  getHAConfig() {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/GetHAConfiguration`;
    return this.http.get(baseUrl);
  }

  updateHAConfig(config: any, userId: string) {
    config.currentHostIp = this.currentHostIp;
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/UpdateHAConfiguration`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, config, { headers: header });
  }

  GetHostsInformation(userId: string){
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/HostsInfo`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }

  GetSyncStatus(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/SyncStatus`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }

  startDBSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StartDatabaseSync`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { responseType: 'text', headers: header });
  }

  stopDBSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StopDatabaseSync`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { responseType: 'text', headers: header });
  }

  manualDBSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/SyncDatabaseManually`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, {}, { headers: header });
  }

  startFSSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StartFileSystemSync`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { responseType: 'text', headers: header });
  }

  stopFSSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StopFileSystemSync`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { responseType: 'text', headers: header });
  }
  
  manualFSSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/SyncFileSystemManually`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, {}, { headers: header });
  }

  startJobsSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StartJobRevival`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }

  stopJobsSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/StopJobRevival`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }
  
  manualJobsSync(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/ManualJobRevival`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, {}, { headers: header });
  }

  checkDBLinking(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/CheckDBLinking`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }
  
  configureLinking(haConfig: HAConfig, linkType: 'primary-to-secondary' | 'secondary-to-primary', userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/LinkServer`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp,
      'LinkDirection': linkType
    };
    return this.http.post(baseUrl, haConfig, { headers: header });
  }

  updateHostIps(formData: { CurrentHostIp: string; OtherHostIp: string }) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/UpdateSyncHpcHostIp`;
    return this.http.post(baseUrl, formData);
  }

  GetLinkedServersInfo(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/GetDbLinkedServerInfo`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.get(baseUrl, { headers: header });
  }

  resetHASystem(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/ResetHASystem`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, {}, { headers: header });
  }

  makeCurrentHostPrimary(userId: string) {
    const baseUrl = `${this.envs.envVariables.httpProtocol}${this.envs.envVariables.webHost}SyncConfiguration/HA/MakeCurrentHostPrimary`;
    const header = {
      'Content-Type': 'application/json',
      'UserId': userId,
      'HostIP': this.currentHostIp
    };
    return this.http.post(baseUrl, {}, { headers: header });
  }
}
